import { Metadata } from "./AppModel";
import { PlacementTest } from "./PlacementTest";
import { EapProgram } from "./School";

export interface StudentRegisterFormModel {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  confirmPassword?: string;
  city: string;
  country: string;
  dateOfBirth: string;
  currentSchool: string;
  currentSchoolYear: string;
  considerEAP: boolean;
  institution: string;
  programInterest: string;
  promotionCode: string;
}
export interface Student
  extends PlacementTest,
    StudentRegisterFormModel,
    Metadata {
  _id: string;
  photoUrl?: string;
  // agentName: string;
  // agentEmail: string;
  // agentPhone: string;
  entrolledCourse: EapProgram;
  programProgress: any;
  classroom?: StudentClassroom;
  isActive?: boolean;
}

export interface StudentListItem {
  name: string;
  id: string;
  email: string;
  enrolledAt?: Date;
  programName?: string;
  currentSchool?: string;
}

export interface StudentClassroom {
  classroomId: string;
  programName: string;
  teacherName: string;
  enrolledAt: Date;
}

export enum StudentState {
  /** Student account is deactivated by teacher/admin */
  INACTIVE = "INACTIVE",
  /** Student has no classroom assignment yet */
  UNASSIGNED = "UNASSIGNED",
  /** Student's program name is invalid/unrecognized */
  INVALID_PROGRAM = "INVALID_PROGRAM",
  /** Student is fully active and can access classroom */
  ACTIVE = "ACTIVE",
}

/**
 * Maximum weeks per program
 */
export const PROGRAM_MAX_WEEKS: Record<EapProgram, number> = {
  [EapProgram.EAP_YELLOW]: 20,
  [EapProgram.EAP_GREEN]: 20,
  [EapProgram.EAP_ACCESS]: 12,
};

/**
 * Routes for each student state
 */
export const STUDENT_STATE_ROUTES: Record<StudentState, string> = {
  [StudentState.INACTIVE]: "/student/account-inactive",
  [StudentState.UNASSIGNED]: "/student/waiting-assignment",
  [StudentState.INVALID_PROGRAM]: "/student/contact-teacher",
  [StudentState.ACTIVE]: "/student/my-classroom",
};

/**
 * Teacher info from classroom (matches API response)
 */
export interface TeacherInfo {
  id: string;
  name: string;
  email: string;
}

/**
 * Course progress within classroom (matches API response)
 */
export interface CourseProgress {
  currentWeek: number;
  overallProgress: number;
  lastActivity: string;
}

/**
 * Extended classroom with full API response structure
 */
export interface MyClassroom extends StudentClassroom {
  startDate: string;
  endDate: string;
  pace: number;
  teacher: TeacherInfo;
  courseProgress: CourseProgress;
}

/**
 * Derived student state for routing decisions
 */
export interface DerivedStudentState {
  state: StudentState;
  isReady: boolean;
  classroom: MyClassroom | null;
  programName: EapProgram | null;
  currentWeek: number;
  maxWeeks: number;
  targetRoute: string;
  teacher: TeacherInfo | null;
  weekWasCapped: boolean;
}
